import { gql } from '@apollo/client'

export const RUN_GROUP_CLEARANCE = gql`
  mutation RunGroupClearance($inputData: RunGroupClearanceInput!) {
    runGroupClearance(inputData: $inputData)
  }
`
